import { ProjectStatusE, StatusE } from "../../models/enums";

export const isRawAllowedForBroadcaster = (deliveryStatus: string | number) => {
  if (typeof deliveryStatus === "string") {
    return (
      deliveryStatus === StatusE.ApprovedAndSentToBroadcaster ||
      deliveryStatus === StatusE.DownloadedByBroadcaster ||
      deliveryStatus === StatusE.DownloadedByAllBroadcasters ||
      deliveryStatus === StatusE.Closed ||
      deliveryStatus === StatusE.Cancelled ||
      deliveryStatus === StatusE.Rejected
    );
  } else {
    return (
      deliveryStatus === ProjectStatusE.ApprovedAndSentToBroadcaster ||
      deliveryStatus === ProjectStatusE.DownloadedByBroadcaster ||
      deliveryStatus === ProjectStatusE.DownloadedByAllBroadcasters ||
      deliveryStatus === ProjectStatusE.Closed ||
      deliveryStatus === ProjectStatusE.Cancelled ||
      deliveryStatus === ProjectStatusE.Rejected
    );
  }
};
